/* eslint-disable no-undef */
import { message } from '@fuxi/eevee-ui';

export let isSdkReady = false;
export let ysfUrl = '';
window.ysf?.('onready', () => {
  isSdkReady = true;
  ysfUrl = ysf?.('url');
});

export const ysfConfig = ({ userInfo: { uid, phone, email }, name, activity = '' }) => {
  window.ysf?.('config', {
    uid,
    name: name,
    email: email,
    mobile: phone,
    data: JSON.stringify([{ key: 'activity', value: activity, label: '活动名称' }]),
  });
};

export const ysfOpen = infoConfig => {
  if (isSdkReady) {
    ysfConfig(infoConfig);
    window.ysf?.('open');
  } else {
    message.info('操作过快，请稍后再试！');
  }
};

export const ysfClose = () => {
  window.ysf?.('close');
};
export const awaitYsfOpen = config => {
  return new Promise((resolve, reject) => {
    ysf('onready', () => {
      resolve();
    });
    reject();
  })
    .then(() => {
      ysf('config', {
        ...(config || {}),
        success: function () {
          // 成功回调
          ysf('open');
        },
      });
    })
    .catch(() => message.info('操作过快，请稍后再试！'));
};
